export default "\nHolbæk Museum is a part of Museum Vestsjælland. They opened their escape room in July 2020.";